import React, { useState, useEffect } from "react";
import { useNavigate } from "react-router-dom";
import { useDispatch, useSelector } from "react-redux";
import apiCall from "./../../API/API";
import { Container, Row, Col, Button } from "react-bootstrap";
import { toast } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";

const BlockActivities = ({ user }) => {
  const [username, setUsername] = useState(user?.username || "");
  const [activities, setActivities] = useState([]);
  const BlockActivities = async () => {
    const { data, error } = await apiCall("GET", "/getAllActivities");
    if (error) {
      toast.error(error.message);
    } else {
      setActivities(data?.data);
    }
  };
  useEffect(() => {
    BlockActivities();
  }, []);
  return (
    <React.Fragment>
      <Container>
        <div id="directIncomeDiv">
          <Row id="directTableRow" className="text-center">
            <Col md="12" className="p-0">
              <div style={{ width: "100%" }}>
                <table>
                  <tr>
                    <th>S. No.</th>
                    <th>Activities</th>
                  </tr>
                  <tbody>
                    {Array.isArray(activities) &&
                      activities.map((row, index) => (
                        <tr key={index}>
                          <td style={{ textAlign: "center" }}>{index + 1}</td>
                          <td style={{ textAlign: "center" }}>
                            {row.description}
                          </td>
                        </tr>
                      ))}
                  </tbody>
                </table>
              </div>
            </Col>
          </Row>
        </div>
      </Container>
    </React.Fragment>
  );
};

export default BlockActivities;
